<template>
  <div class="parapharmacy-template-selector__network-error-container">
    <div class="mb-4">{{ $t('parapharmacy_templates_selector.network_error') }}</div>
    <div>
      <v-btn depressed color="primary" :disabled="loading" @click="retry">
        <v-icon left>
          mdi-refresh
        </v-icon>
        {{ $t('parapharmacy_templates_selector.retry') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParapharmacyTemplateSelectorNetworkError',
  props: ['retry', 'loading'],
};
</script>

<style>
.parapharmacy-template-selector__network-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
